<div *ngIf="dates?.length" class="item" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px">
    <div
        fxLayout="column"
        fxLayoutAlign="start center"
        fxLayoutGap="15px"
        class="dates"
        [ngClass]="{ 'm-0': canShowMore ? index > 1 : false }"
        *ngFor="let occ of dates; let index = index"
    >
        <div *ngIf="canShowMore ? index < 2 : true" class="w-100" fxLayout="column" fxLayoutAlign="start start">
            <ng-container *ngIf="occ.application_start_date && occ.application_end_date">
                <span>Application Open:</span>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span i18n>From:</span>
                    <span>{{ occ.application_start_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    <span i18n>To:</span>
                    <span>{{ occ.application_end_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    <span *ngIf="timeZone">{{ timeZone }}</span>
                </div>
            </ng-container>
            <ng-container *ngIf="occ.start_date && occ.end_date">
                <span>Course Starts:</span>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span i18n>From:</span>
                    <span>{{ occ.start_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    <span i18n>To:</span>
                    <span>{{ occ.end_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    <span *ngIf="timeZone">{{ timeZone }}</span>
                </div>
            </ng-container>
        </div>
    </div>
    <ng-container *ngIf="canShowMore">
        <div (click)="showMoreDates()" *ngIf="dates?.length > 2" class="dates more">
            <span>Show {{ dates?.length - 2 }} more</span>
        </div>
    </ng-container>
</div>
<ng-template #all_occasion_dates>
    <div
        fxLayout="column"
        fxLayoutAlign="start center"
        fxLayoutGap="15px"
        class="dates-res-occasions"
        *ngFor="let occ of dates; let index = index"
    >
        <div class="w-100" fxLayout="column" fxLayoutAlign="start start">
            <ng-container *ngIf="occ.application_start_date && occ.application_end_date">
                <span>Application Open:</span>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span i18n>From:</span>
                    <span>{{ occ.application_start_date | kdDateFormat : 'MMM DD, YYYY' }}</span>

                    <span i18n>To:</span>
                    <span>{{ occ.application_end_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    <span *ngIf="timeZone">{{ timeZone }}</span>
                </div>
            </ng-container>
            <ng-container *ngIf="occ.start_date && occ.end_date">
                <span>Course Starts:</span>
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                    <span i18n>From:</span>
                    <span>{{ occ.start_date | kdDateFormat : 'MMM DD, YYYY' }}</span>

                    <span i18n>To:</span>
                    <span>{{ occ.end_date | kdDateFormat : 'MMM DD, YYYY' }}</span>
                    <span *ngIf="timeZone">{{ timeZone }}</span>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
